import { Pipe, PipeTransform } from '@angular/core';

const getDistanceValue = (nursery) => {
  const nurseryItem = nursery.item || nursery;
  if (nurseryItem && nurseryItem.distance && nurseryItem.distance.value) {
    return nurseryItem.distance.value;
  }
}

@Pipe({
  name: 'orderByDistance'
})

export class OrderByDistancePipe implements PipeTransform {

  transform(nurseriesArray: any): any {
    if (!nurseriesArray) return nurseriesArray;
    nurseriesArray.sort((a: any, b: any) => {
      getDistanceValue(a) - getDistanceValue(b);
    }).reverse();
    return nurseriesArray;
  }

}
